// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"_3F0sZR1k","list":"EM-7MreB flex flex-wrap list-reset m0","crumb":"_3JPAKES6","crumb-link":"_2gAZBa13","crumbLink":"_2gAZBa13"};